export interface IReviewOrder {
  ProductTitle: string;
  UserName: string;
  IsLoggedInUser: boolean;
  Total: string;
}

export const ReviewOrderDetails: IReviewOrder = {
  ProductTitle: 'Std 650: Welded Tanks for Oil Storage, Thirteenth Edition',
  UserName: '',
  IsLoggedInUser: false,
  Total: '$5,650.00',
};

export default {};
